import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import OrphanedAssignmentService from '../../../../Services/OrphanedAssignmentService';
import OrphanedAssignmentsProjectGroupedByClientItem from '../../../../Domain/OrphanedAssignmentsProjectGroupedByClientItem';

export default class OrphanedAssignmentsProjectGroupedByClientAdmin extends React.Component {
  static defaultProps = {
    officeId: null,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={OrphanedAssignmentsProjectGroupedByClientItem}
          serviceFunction={OrphanedAssignmentService.GetOrphanedAssignmentsProjectGroupedByClient}
          convertDBItemsFunction={OrphanedAssignmentService.ConvertOrphanedAssignmentsProjectGroupedByClientDBItems}
          searchItem={{ OfficeId: this.props.officeId }}
          orderBy='AsSassieSurveyId'
          errorCode='OAPGBCA26'
        />
      </div>
    );
  }
}
